export const REPIQ_PRESET_PROFILE = "REPIQ_PRESET_PROFILE";
export const SHOW_LOADER = "SHOW_REPIQ_PRESETPROFILE_SERVICE_LOADER";

export interface IPresetProfileState {
    presetProfileData?: IProfileCategory[];
    isLoading: boolean;
}

export interface IProfileCategory {
    profileCategoryID: number;
    profileCategoryName: string;
    profiles: IProfile[];
}

export interface IProfile {
    profileID: number;
    profileName: string;
    categories: ICategories;
}

export interface ICategories {
    Agreeableness: { high: number; low: number };
    Conscientiousness: { high: number; low: number };
    EmotionalRange: { high: number; low: number };
    OpennessToExperiences: { high: number; low: number };
    Extraversion: { high: number; low: number };
}

export interface getRepIQPresetProfile {
    type: "REPIQ_PRESET_PROFILE";
    repIQPresetProfileData: IProfileCategory[];
}
export interface ShowAction {
    type: "SHOW_REPIQ_PRESETPROFILE_SERVICE_LOADER";
    isLoading: boolean;
}

export type KnownAction = getRepIQPresetProfile | ShowAction;
